import { createContext, useContext } from 'react'
import { ObservableEvent } from './libs/useObservable'

const SliderContext = createContext({})

interface SliderContextProps {
  slideMove: ObservableEvent
  slideEnd: ObservableEvent
  slideStart: ObservableEvent
  isDragging: boolean
  max: number
  min: number
  currentThumbValue: number
  currentValue: Array<number>
}

export const useSlider = (): SliderContextProps => useContext(SliderContext) as SliderContextProps
export default SliderContext
